import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["avatarHash", "email", "displayName", "renderName"];
// @ts-expect-error Library not migrated yet
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import styled from 'styled-components';
import { getAvatarUrl } from '../avatarQueries';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Avatar = styled(UIAvatar).withConfig({
  displayName: "AvatarViewer__Avatar",
  componentId: "h70s5h-0"
})(["box-sizing:border-box;"]);
export const AvatarViewer = _ref => {
  let {
      avatarHash,
      email,
      displayName,
      renderName
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    gap: 8,
    children: [/*#__PURE__*/_jsx(Avatar, Object.assign({
      className: "",
      displayName: displayName,
      hubSpotUserEmail: email,
      size: "xl",
      src: avatarHash && getAvatarUrl(avatarHash)
    }, props)), renderName && displayName]
  });
};